// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2_Y4Q","clinicsSelect":"TableHeading_clinicsSelect__1acpd"};